import type { IProgram } from '../../api/src/programs';
import type { IEventView } from './events';
import type { IApplicationView, IClientView, IItemView, IPersonView } from './model';
import type { RecordSet } from './FirmRecords';

export interface ITabData {
  /** The lists this application is in (main or restricted), and its library. */
  set: RecordSet;
  application: IApplicationView;
  client?: IClientView;
  program?: IProgram;
  people: IPersonView[];
  items: IItemView[];
  events: IEventView[];
}

function escape(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** The request to the client, as a page: what's still needed, per person. */
export function requestHtml(d: ITabData, items: IItemView[], firm: string, today: string): string {
  const name = (key: string): string => d.people.filter(p => p.key === key)[0]?.name ?? '';
  const groups: { title: string; items: IItemView[] }[] = [
    ...d.people.map(p => ({ title: p.name, items: items.filter(i => i.personKey === p.key) })),
    { title: 'For the whole file', items: items.filter(i => !i.personKey || !name(i.personKey)) }
  ].filter(g => g.items.length);
  const label = (i: IItemView): string => i.label.replace(new RegExp(` \\(${name(i.personKey).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\)$`), '');
  return `<!doctype html><html><head><meta charset="utf-8"><title>Documents we need</title>
<style>body{font-family:Segoe UI,Arial,sans-serif;max-width:760px;margin:32px auto;color:#1b1b1b;line-height:1.5}h1{font-size:22px}h2{font-size:17px;margin-top:22px}li{margin:4px 0}.small{color:#555;font-size:13px}</style></head><body>
<h1>Documents we still need</h1>
<p>${escape(d.client?.name ?? '')} · ${escape(d.program?.name ?? '')} · ${escape(today)}</p>
<p>To prepare your application, please send us the documents below. Documents not in English or French need a translation and the translator's affidavit.</p>
${groups.map(g => `<h2>${escape(g.title)}</h2><ul>${g.items.map(i => `<li>${escape(label(i))}${i.form ? ` (${escape(i.form)})` : ''}</li>`).join('')}</ul>`).join('\n')}
<p class="small">${escape(firm)}</p>
</body></html>`;
}

